import {ErrorController} from '../../../../../../shared/errors/ErrorController'
import {ClientUserState} from '../../../../../shared/scripts/ClientUserState'
import {UIErrorHandler} from '../../../../../shared/scripts/errors/UIErrorHandler'
import {UIHeaderController} from '../../../../../shared/scripts/ui_html/header/UIHeaderController'
import {removeURLParams} from '../../../../../shared/scripts/ui_utils/Utils'
import {UIMHeaderHamburgerController} from './UIMHeaderHamburgerController'
import {UIMHeaderProfileController} from './UIMHeaderProfileController'
import {setElementInnerHTML} from '../../../../../shared/scripts/ui_utils/DomUtils'
import {UINotificationPanelController} from '../../../../../shared/scripts/notifications/UINotificationPanelController'
import {UIAjaxWrapper} from '../../../../../shared/scripts/network/UIAjaxWrapper'
import {UIAPIEndpoints} from '../../../../../shared/scripts/network/UIAPIEndpoints'
import {AjaxDataTypes} from '../../../../../../shared/AjaxDataTypes'
import {ViewPopupEditProfile} from '../../../../../shared/scripts/ui_popup/ViewPopupEditProfile'
import {PlayerColor} from '@colonist/game-states'
import {ProfileEditAjaxEndPoints} from '../../../../../shared/scripts/profile/ProfileEditAjaxEndPoints'
import {UIMProfileUsernameController} from '../body/UIMProfileUsernameController'

export class UIMHeaderController extends UIHeaderController {
    private readonly headerContainer: HTMLDivElement
    readonly profileController: UIMHeaderProfileController
    readonly hamburgerController: UIMHeaderHamburgerController
    readonly notificationPanelController: UINotificationPanelController | undefined

    constructor() {
        super()
        this.headerContainer = document.getElementById('header-container') as HTMLDivElement
        this.profileController = new UIMHeaderProfileController()
        this.hamburgerController = new UIMHeaderHamburgerController()
        this.notificationPanelController = new UINotificationPanelController()

        UIMHeaderController.displayRedirectErrors()
        ClientUserState.registerChangeListener(() => {
            this.updateHeaderData()
        })
    }

    hide() {
        this.headerContainer.style.display = 'none'
        this.hamburgerController.hide()
    }

    show() {
        this.headerContainer.style.display = 'flex'
        this.hamburgerController.show()
    }

    private updateHeaderData() {
        if(ClientUserState.userState == undefined) return
        const userNameElement = document.getElementById('header-element-profile-name') as HTMLDivElement
        const karmaElement = document.getElementById('header-element-profile-karma') as HTMLDivElement

        userNameElement.innerText = ClientUserState.userState.username
        userNameElement.onclick = () => UIMHeaderController.openEditProfilePopup()
        setElementInnerHTML(karmaElement, ClientUserState.userState.getPlayerKarmaStatusText())
        this.profileController.updateMembershipIcon(ClientUserState.userState)

        const iconElement = document.getElementById('header-element-profile-avatar') as HTMLImageElement

        UIMHeaderProfileController.updateIcon(ClientUserState.userState.icon, iconElement)

        iconElement.onclick = () => UIMHeaderController.openEditProfilePopup()

        void this.addFriendRequestsToNotificationPanel()
    }

    private static openEditProfilePopup() {
        new ViewPopupEditProfile({
            usernameController: UIMProfileUsernameController,
            selectColorAction: async(color: PlayerColor) => await ProfileEditAjaxEndPoints.updatePreferredColor(color),
        })
    }

    private static displayRedirectErrors() {
        const urlSearchParams = new URLSearchParams(window.location.search)

        const error = urlSearchParams.get('error')
        if(error == null) return

        const parsedError = JSON.parse(error)
        const deserializedError = ErrorController.deserializeErrorData(parsedError)

        UIErrorHandler.handleError(deserializedError)
        removeURLParams()
    }

    // eslint-disable-next-line class-methods-use-this
    private async addFriendRequestsToNotificationPanel() {
        if(ClientUserState.userState == undefined) return
        const friendRequestsResponse = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiFriendRequestsReceived(), undefined)
        if(friendRequestsResponse == undefined) return
        const friendRequests = friendRequestsResponse.json as AjaxDataTypes.FriendRequestReceivedData[]
        const friendRequestsNumber: number = friendRequests !== undefined ? friendRequests.length : 0
        if(friendRequestsNumber === 0) return

        if(this.notificationPanelController == undefined) return

        for(const friendRequestReceived of friendRequests) {
            this.notificationPanelController.addFriendRequestNotification(friendRequestReceived.username, new Date(friendRequestReceived.dateCreated))
        }
    }
}
